import React, { useState } from "react"
import { setPaymentGatewaysField, fetchPaymentGateways, cancelLastPaymentGateway } from "../../../../../actions/paymentGatewaysActions";
import { ConfigConstants } from "../../../../../utils/config";
import { IPaymentGatewayElement } from "../../../../../models/Configuration";
import { UpdateCheckoutDotComGatewayRequest } from "../../../../../utils/grpc/generated/Billsby.Protos/billing/private/paymentgateway/payment_gateway_pb";
import { PaymentGatewayServiceClient } from "../../../../../utils/grpc/generated/Billsby.Protos/billing/private/paymentgateway/Payment_gatewayServiceClientPb";
import { grpcUnaryCall } from "../../../../../utils/grpc/grpcUtils";
import PaymentGatewayContainer from "../payment-gateways-shared-components/PaymentGatewayContainer";
import CheckoutPaymentGatewayForm from "./CheckoutPaymentGatewayForm";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../../..";
import { IAuthReducerState } from "../../../../../reducers/authReducer";

interface Props {
  paymentGateway: IPaymentGatewayElement,
  isOneGatewayPending: boolean,
  currentGatewayState: any,
  idx: number,
  isCreatingGateway: boolean,
  onError: () => void
}

const CheckoutPaymentGatewayUpdate: React.FC<Props> = ({ onError, paymentGateway, isOneGatewayPending, currentGatewayState, idx, isCreatingGateway }) => {

  const { currentCompanyDomain } = useSelector<AppState, IAuthReducerState>(state => state.auth)
  const dispatch = useDispatch<Function>()
  const [helpTitle, setHelpTitle] = useState("PAYMENT_GATEWAYS_ADDED_CHECKOUT_HELP_TITLE");
  const [helpContent, setHelpContent] = useState(["PAYMENT_GATEWAYS_ADDED_CHECKOUT_HELP_CONTENT_1", "PAYMENT_GATEWAYS_ADDED_CHECKOUT_HELP_CONTENT_2"]);

  const cancelChanges = () => {
    paymentGateway.mustActivate ? dispatch(cancelLastPaymentGateway())
      : dispatch(setPaymentGatewaysField(`paymentGateway${idx}`, { ...currentGatewayState, displayName: paymentGateway.title, isCollapsed: true }))
  }

  const updatePaymentGateway = async (displayName: string, secretKey: string) => {
    const updateCheckoutDotComGatewayRequest = new UpdateCheckoutDotComGatewayRequest();
    updateCheckoutDotComGatewayRequest.setCompanyDomain(currentCompanyDomain);
    updateCheckoutDotComGatewayRequest.setDisplayName(displayName);
    updateCheckoutDotComGatewayRequest.setSecretKey(secretKey);
    updateCheckoutDotComGatewayRequest.setPaymentGatewayId(paymentGateway.paymentGatewayId as number);
    const paymentGatewayServiceClient = new PaymentGatewayServiceClient(ConfigConstants.grpcBaseUrl);
    try {
      await grpcUnaryCall(updateCheckoutDotComGatewayRequest, paymentGatewayServiceClient, paymentGatewayServiceClient.updateCheckoutDotComGateway);
      await dispatch(fetchPaymentGateways(currentCompanyDomain));
      dispatch(setPaymentGatewaysField(`paymentGateway${idx}`, { ...currentGatewayState, isCollapsed: true }));
    } catch {
      onError();
    }
  }

  return (
    <PaymentGatewayContainer
      helpTitle={helpTitle}
      helpContent={helpContent}
      description="PAYMENT_GATEWAYS_CHECKOUT_DESCRIPTION"
      isOneGatewayPending={isOneGatewayPending}
      currentGatewayState={currentGatewayState}
      onClick={() => dispatch(setPaymentGatewaysField(`paymentGateway${idx}`, { ...currentGatewayState, isCollapsed: paymentGateway.mustActivate ? false : !currentGatewayState.isCollapsed }))}
      websiteLink="https://checkout.com/"
      type="edit"
      paymentGateway={paymentGateway}
    >
      <CheckoutPaymentGatewayForm
        onSave={(displayName: string, secretKey: string) => updatePaymentGateway(displayName, secretKey)}
        onCancel={() => cancelChanges()}
        setHelpTitle={(text: string) => setHelpTitle(text)}
        setHelpContent={(text: Array<string>) => setHelpContent(text)}
        initDisplayName={paymentGateway.title}
        isSaveEnabled={!isCreatingGateway}
        isEdit={true}
      />
    </PaymentGatewayContainer>
  )
}

export default CheckoutPaymentGatewayUpdate
